export default function Buttons() {
    return(
        <>
            <a href="https://wa.me/+201146234265?text=ممكن تفاصيل دورة مفاتيح الحب الأبدي" target="blank"><button className="button-call-now">Call Now</button></a>
        </>
    )
}